import DataViewsService from "@/core/services/dataViewsService";

export default ({ $log, $axios, app }: any, inject: any) => {
  inject(
    "dataViews",
    new DataViewsService($log, $axios, app.$eventBus, app.$sessionStorage),
  );
};
